import XhrRequestHandler from '../../lib/XhrRequestHandler';

export interface ProjectEnhancementOptionsPayload {
  /* required */
  project_name: string;
  /* optional */
  project_description: string;
}
export interface EnhancedProject {
  project_name: string;
  project_description: string;
}

export class AiProjectEnhancementSystem {
  private readonly base = '/prompt/project-complete';

  constructor(private requestHandler: XhrRequestHandler) {}

  async enhanceProject(payload: ProjectEnhancementOptionsPayload): Promise<EnhancedProject> {
    return this.requestHandler.post<EnhancedProject>(this.base, payload);
  }
}
